import timeComponent from './lib/timeComponent.js';
import dayComponent from './lib/dayComponent.js';

const scheduleComponent = (componentNode) => {
  const block = componentNode;
  const dayNodes = Array.from(block.querySelectorAll('.jsScheduleDay'));
  const inputFrom = block.querySelector('.jsScheduleInputFrom');
  const inputTo = block.querySelector('.jsScheduleInputTo');

  const time = timeComponent({
    fromNode: inputFrom,
    toNode: inputTo,
  });

  const days = dayNodes.map((dayNode) => dayComponent({ dayNode }));
  const [firstDay] = days;

  time.update(firstDay.getTime());

  const hasFocusedDay = () => (
    days.filter(({ getFocusing }) => getFocusing() === 'focused').length
  );

  const getFocusedDay = () => {
    const [focusedDay] = days.filter(({ getFocusing }) => getFocusing() === 'focused');

    return focusedDay;
  };

  const validateDay = (day) => {
    const dayTime = day.getTime();

    return time.validate(dayTime) ? 'valid' : 'invalid';
  };

  const updateFocusedDay = () => {
    const focusedDay = hasFocusedDay() ? getFocusedDay() : days[0];

    if (!focusedDay) return;

    const currentTime = time.toString(time.getValue());

    if (!currentTime) return;

    focusedDay.updateTime(currentTime);
  };

  const setDay = (day) => {
    const currentTimeValue = time.toString(time.getValue());
    const dayTime = day.getTime();

    day.updateActivity('active');
    day.updateFocusing('focused');

    if (!dayTime && currentTimeValue) {
      day.updateTime(currentTimeValue);
      return;
    }

    time.update(dayTime);
  };

  const unsetDay = (day, shouldInactiveDay = false) => {
    if (!day) return;

    day.updateFocusing('unfocused');

    if (shouldInactiveDay) {
      day.updateTime('');
      time.clear();
      day.updateActivity('inactive');
    }
  };

  // eslint-disable-next-line no-unused-vars
  const writeSystemLog = () => {
    console.debug('%cUpdated schedule:', 'background-color: yellow');
    days.forEach((day) => {
      const { node } = day;
      const input = node.querySelector('input');
      const dayName = input.name;
      // console.log(dayName, input.value);
    });
  };

  days.forEach((day, index) => {
    const { node } = day;

    node.addEventListener('click', () => {
      if (!hasFocusedDay()) {
        setDay(day, index);
        time.fromNode.focus();

        // writeSystemLog();
        return;
      }

      if (day.getFocusing() === 'focused') {
        unsetDay(day, true);

        // writeSystemLog();
        return;
      }

      const focusedDay = getFocusedDay();
      const shouldInactiveDay = validateDay(focusedDay) === 'invalid';

      unsetDay(focusedDay, shouldInactiveDay);
      setDay(day, index);
      time.fromNode.focus();

      // writeSystemLog();
    });
  });

  block.addEventListener('change', (event) => {
    const target = event.target.closest('.jsScheduleInputFrom');

    if (!target) {
      return;
    }

    const { value } = target;

    time.setValue({ from: value });
    updateFocusedDay();

    if (value) {
      time.toNode.focus();
    }
  });

  block.addEventListener('change', (event) => {
    const target = event.target.closest('.jsScheduleInputTo');

    if (!target) {
      return;
    }

    time.setValue({ to: target.value });
    updateFocusedDay();
  });
};

const init = (selector = '.jsSchedulePicker') => {
  const componentNodes = Array.from(document.querySelectorAll(selector));

  componentNodes.forEach(scheduleComponent);
};

document.addEventListener('DOMContentLoaded', () => {
  init();
});

window.jsSchedulePicker = init;
